import React from "react";
import ReactDOM from "react-dom";
import Main from "./Main";
import "./css/index.css";
 
ReactDOM.render(
  <Main/>, 
  document.getElementById("Main")
);



// WEBPACK FOOTER //
// ./src/index.js